module.exports = __webpack_public_path__ + "static/media/YB5F04_1.3a23e2ff.jpg";